<template>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="70"
          ></v-progress-circular>
          <h1 class="display-2 font-weight-bold mb-4">Loading Permissions...</h1>
          <p class="subtitle-1 mb-5">
            Please wait while we load the necessary permissions for your account.
          </p>
          <v-btn color="primary" @click="fetchPermissionsAndRedirect">
            Retry Loading Permissions
          </v-btn>
          <v-btn text color="primary" @click="goBack">
            Go Back
           </v-btn>
          <!-- <v-btn text color="primary" @click="testing">
            Testing Banner
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "LoadingPermission",
    methods: {

        // fetchPermissions() {
        //     this.$store.dispatch("fetchAndStorePermissions");
        // },
        async fetchPermissionsAndRedirect() {
            try {
                await this.$store.dispatch("fetchAndStorePermissions");
                if (this.$store.getters.hasPermissions) {
                    this.$router.replace({ path: this.$route.redirectedFrom || '/' });
                } else {
                    throw new Error("Permissions are empty after fetch.");
                }
            } catch (error) {
                console.error("Failed to load permissions:", error);
                this.$toast.error("Failed to load permissions. Please try again."); // Assuming you have a toast service
            }
        },

        goBack() {
            // Method to navigate back to the previous page
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'Home' }); // Fallback if no history is available
            }
        } 
    //   testing() {
    //     // Additional testing method, triggers permission fetching
    //     this.fetchPermissions();
    //   }
    }
  };
  </script>
  
  <style scoped>
  </style>